import {defineMessages} from "react-intl";

export const PageGroupMessages = defineMessages({
  fleet: {
    id: "pageGroup.fleet.title",
    defaultMessage: "My aircraft fleet",
  },
  profile: {
    id: "pageGroup.profile.title",
    defaultMessage: "Profile",
  },
})
